<template>
  <div
    id="dropdown-container"
    :style="{
      width: width || '240px',
    }"
  >
    <div class="select-text" @click.stop.passive="toggleSelect">
      <span>{{ selected.value }}</span>
      <span class="af af-chevron-down select-arrow"></span>
    </div>
    <transition name="fade">
      <div v-if="dropdownActive" class="select-list">
        <div v-for="(option, index) of options" :key="index" class="select-item" @click.stop.passive="onChange($event, option)">
          {{ option.value }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    value: Object,
    options: Array,
    width: String,
  },
  data() {
    return {
      selected: this.value || { value: 'Select' },
      dropdownActive: false,
    };
  },
  mounted() {
    window.addEventListener('click', this.onWindowClick, { passive: true });
  },
  destroyed() {
    window.removeEventListener('click', this.onWindowClick);
  },
  methods: {
    onWindowClick() {
      this.dropdownActive = false;
    },
    onChange(event, value) {
      this.selected = value;
      this.onWindowClick();
      this.$emit('input', value);
    },
    toggleSelect() {
      this.dropdownActive = !this.dropdownActive;
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active {
  transition: opacity ease-out 150ms;
}
.fade-leave-active {
  transition: opacity ease-in 150ms;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

#dropdown-container {
  position: relative;
  cursor: pointer;

  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  .select-text,
  .select-list {
    box-sizing: border-box;
    width: 100%;
  }

  .select-text {
    font-size: var(--font-size-16);
    font-weight: bold;
    padding: 4px 12px;
    border: 1px solid rgba(211, 211, 211, 0.6);
    display: flex;
    justify-content: space-between;
    align-items: center;

    transition: border linear 200ms;

    &:hover {
      border: 1px solid rgba(211, 211, 211, 1);
    }

    .select-arrow {
      transition: transform ease-out 200ms;
    }
  }

  .select-list {
    position: absolute;
    z-index: 3;
    border: 1px solid rgba(211, 211, 211, 0.6);
    border-top: none;
    box-shadow: 0px 20px 32px 0px rgba(0, 0, 0, 0.2);

    .select-item {
      background: white;
      height: 24px;
      padding: 8px 12px;
      display: flex;
      align-items: center;

      transition: background linear 100ms, color linear 100ms;

      &:hover {
        background: #666666;
        color: white;
      }
    }
  }
}
</style>
